import { useMemo, useState } from "react";
import { lifeNotes, noteTags } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Notes() {
  const [activeTag, setActiveTag] = useState("全部");

  const visibleNotes = useMemo(
    () => (activeTag === "全部" ? lifeNotes : lifeNotes.filter((n) => n.tag === activeTag)),
    [activeTag]
  );

  return (
    <section id="notes" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Daily Notes"
          title="生活碎碎念"
          description="不完整、不隆重，只是某天忽然想说的一句话。按主题筛一筛，看看有没有和你此刻心情对得上的一段。"
        />

        <div className="mt-8 flex flex-wrap items-center gap-2">
          {noteTags.map((tag) => {
            const active = tag === activeTag;
            return (
              <button
                key={tag}
                type="button"
                onClick={() => setActiveTag(tag)}
                aria-pressed={active}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer border ${
                  active
                    ? "bg-foreground-900 text-background-50 border-foreground-900"
                    : "bg-background-100 text-foreground-700 border-background-200 hover:border-secondary-300 hover:text-secondary-800"
                }`}
              >
                {tag}
              </button>
            );
          })}
          <span className="ml-auto text-xs text-foreground-500">
            共 {visibleNotes.length} 则
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {visibleNotes.map((note) => (
            <article
              key={note.title}
              className="flex flex-col bg-background-100 border border-background-200 rounded-lg p-5 hover:border-accent-300 transition-colors"
            >
              <span className="w-10 h-10 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className="ri-double-quotes-l text-xl"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {note.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{note.text}</p>
              <span className="mt-4 inline-flex self-start px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label">
                {note.tag}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}